import React from 'react';

// Material components
import {
    Tooltip,
    Divider,
    Container
} from '@material-ui/core';
// Styles
import { makeStyles } from '@material-ui/core/styles';
import texture from '../../assets/images/textures/textures';
import "./styles.css"
import { flex } from '../../assets/jss';
const useStyles = makeStyles((theme) => ({
    storyCard: {
        backgroundColor: 'white',
        backgroundImage: `url(${texture.wrinkled})`,
        backgroundSize: 'cover',
        color: 'black',
        maxWidth: 800,
        width: '90%',
        margin: 12,
        padding: 12,
        textAlign: 'left',
        overflowY: 'scroll',
        cursor: 'pointer'
    },
    cardHeader: {
        color: 'black',
        fontFamily: 'cursive',
        margin: '5px',
        textAlign: 'center'
    },
    textContainer: {
        padding: 0,
        ...flex.flex_row_start,
        flexWrap: 'wrap',
        marginTop: 12,
        alignItems: 'flex-end'
    },
    text: {
        fontSize: '1.2rem',
        padding: '0px 12px'
    }
}));

export default ({ story }) => {
    const classes = useStyles();
    return (
        <div className={classes.storyCard}>
            <h2 className={classes.cardHeader}>{story.title}</h2>
            <sub>by {story.author}</sub>
            <Container className={classes.textContainer}>
                {story.text.map((txt, i) =>
                    <div key={i}>
                        <Tooltip placement='top' title={txt.contributor === null ? "Anonymous" : txt.contributor}>
                            <div className={classes.text}>
                                {txt.words.map((word, i) =>
                                    <span key={i} style={{ fontFamily: txt.fontFamily }}>{word} </span>
                                )}
                            </div>
                        </Tooltip>
                        <Divider />
                    </div>
                )}
            </Container>
        </div>
    )
}